<template>
  <div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('couponList.type') }}:</span>
        <el-radio-group size="medium" v-model="filter.type">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="0">{{ type(0) }}</el-radio>
          <el-radio :label="1">{{ type(1) }}</el-radio>
          <el-radio :label="2">{{ type(2) }}</el-radio>
          <el-radio :label="3">{{ type(3) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('couponList.status') }}:</span>
        <el-radio-group size="medium" v-model="filter.status">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="0">{{ status(0) }}</el-radio>
          <el-radio :label="1">{{ status(1) }}</el-radio>
          <el-radio :label="2">{{ status(2) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t('btnTip.add')
        }}</el-button>
        <el-button type="primary" @click="outExe">{{ $t('outExe') }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:type="slotProps">
          <div>{{ type(slotProps.callback.row.type) }}</div>
        </template>
        <template v-slot:title="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('couponList.toCouponUseList')"
            placement="top"
          >
            <div>{{ slotProps.callback.row.title }}</div>
          </el-tooltip>
        </template>
        <template v-slot:exchange="slotProps">
          <div
            class="under_line"
            @click="handleClick('couponUseList', slotProps.callback.row)"
          >
            {{ slotProps.callback.row.redeem_num }}/{{
              slotProps.callback.row.total_num
            }}
          </div>
        </template>
        <template v-slot:status="slotProps">
          <el-tag :type="statusTag(slotProps.callback.row.status)">
            {{ status(slotProps.callback.row.status) }}
          </el-tag>
        </template>
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').edit"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t('btnTip').delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from '@/mixins';
import page from '@/components/page';
import myTable from '@/components/table';
import { couponList, deleteCoupon } from '@/api/api';
export default {
  name: 'couponList',
  mixins: [mixin_list(couponList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: '',
        type: '',
        status: '',
      },
      columns: [
        {
          label: 'ID',
          sortable: true,
          prop: 'id',
          width: 80,
        },
        {
          label: this.$t('couponList.create_time'),
          sortable: true,
          prop: 'create_time',
        },
        {
          label: this.$t('couponList.type'),
          sortable: true,
          prop: 'type',
          slot: 'type',
        },
        {
          label: this.$t('couponList.title'),
          sortable: true,
          prop: 'title',
          slot: 'title',
        },
        {
          label: this.$t('couponList.amount'),
          sortable: true,
          prop: 'amount',
        },
        {
          label: this.$t('couponList.redeem_code'),
          sortable: true,
          prop: 'redeem_code',
        },
        {
          label: this.$t('couponList.exchange'),
          sortable: true,
          prop: 'redeem_num',
          slot: 'exchange',
        },
        {
          label: this.$t('activityList.status'),
          sortable: true,
          prop: 'status',
          slot: 'status',
        },
        {
          label: this.$t('operation'),
          prop: '',
          width: 300,
          slot: 'operation',
        },
      ],
    };
  },
  methods: {
    type(type) {
      switch (type) {
        case 0:
          return this.$t('couponList.type0');
        case 1:
          return this.$t('couponList.type1');
        case 2:
          return this.$t('couponList.type3');
        case 3:
          return this.$t('couponList.type2');
      }
    },
    statusTag(status) {
      switch (status) {
        case 0:
          return 'info';
        case 1:
          return 'success';
        case 2:
          return 'danger';
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return this.$t('couponList.status0');
        case 1:
          return this.$t('couponList.status1');
        case 2:
          return this.$t('couponList.status2');
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case 'add':
          this.$router.push('/couponManagement/couponList/edit');
          break;
        case 'edit':
          this.$router.push(`/couponManagement/couponList/edit?id=${data.id}`);
          break;
        case 'couponUseList':
          this.$router.push(
            // `/couponManagement/couponList/couponUseList?id=${data.id}`
            `/couponManagement/couponList/edit/setmember?id=${data.id}`
          );
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('couponList').sureDeleteCoupon, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning',
      })
        .then(async () => {
          let res = await deleteCoupon(id);
          this.get_list();
        })
        .catch({});
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  width: 100px;
  font-size: 16px;
}
/deep/ label {
  margin-bottom: 0 !important;
}
</style>
